<template>
  <v-card>
    <v-toolbar dense dark class="elevation-0">
      <v-toolbar-title card color="secondary">
        <v-icon> mdi-tag</v-icon>
        Προσφορές στην Βάση
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-text-field
      v-model="search"
      append-icon="search"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <v-data-iterator
      :search="search"
      :items="b2b.offers"
      row
      wrap
      content-tag="v-layout"
      hide-actions
      class="boxes-front scroll-y"
      :rows-per-page-items="[-1]"
    >
      <v-flex
        lg12
        slot="item"
        slot-scope="props"
      >

        <v-list dense two-line expand>
          <v-list-tile  ripple @click="">

            <v-list-tile-content  @click="filterRelations(props.item.ID)">
                <strong> <span :title="props.item.Title">{{ props.item.Title }}</span> </strong>
            </v-list-tile-content>
            <v-list-tile-action class="pl-0">
              <v-menu
                :close-on-content-click="false"
                :nudge-width="300"
                offset-x
              >
                <v-btn
                  class="pa-0"
                  fab
                  flat
                  color="secondary"
                  small dark
                  slot="activator"
                  dark
                >
                  <v-icon> mdi-chevron-down</v-icon>
                </v-btn>
                <v-card>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>{{props.item.Title}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{props.item.ID}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <!--
                    <v-list-tile  ripple >
                        <v-list-tile-content>
                            {{props.item.HasImages === '1' ?'Απενεργοποιήση Φωτ.':'Ενεργοποιήση Φωτ.'}}
                        </v-list-tile-content>
                        <v-list-tile-action>
                        </v-list-tile-action>

                    </v-list-tile>
                    -->
                    <offer-field-editor :offer-field="props.item.Title"  field-name="Τίτλος" @onSave="updateOfferField(props.item.ID,'Title',$event)"></offer-field-editor>
                    <description-editor :description="props.item.Description"
                                        @onSave="updateOfferField(props.item.ID,'Description',$event)"> Αποθήκευση
                    </description-editor>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title class="mr-2"> Ισχύει από:</v-list-tile-title>
                      </v-list-tile-content>
                      <date-picker style="" :date="props.item.ValidFrom"
                                   @onSave="updateOfferField(props.item.ID,'ValidFrom',$event)"

                      ></date-picker>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content class="mr-2">
                        <v-list-tile-title> Ισχύει εώς:</v-list-tile-title>
                      </v-list-tile-content>
                      <date-picker
                        :date="props.item.ValidTill"
                        @onSave="updateOfferField(props.item.ID,'ValidTill',$event)"
                      ></date-picker>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile ripple
                                 @click="updateOfferField(props.item.ID,'HasImages',props.item.HasImages === '1'?'0':'1')">
                      <v-list-tile-content>
                        {{props.item.HasImages === '0'?'Ενεργοποίηση φωτο.':'Απενεργοποιήση φωτο.' }}
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon color="error"> mdi-tag-image</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile ripple
                                 @click="toggleOffer(props.item.ID,true)">
                      <v-list-tile-content>
                        Ενεργοποίηση προσβάσεων
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon color="success"> mdi-key</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile ripple
                                 @click="toggleOffer(props.item.ID,false)">
                      <v-list-tile-content>
                        Απενε/ποιήση προσβάσεων
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon color="error"> mdi-key-remove</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile color="error" ripple @click="deleteOffer(props.item.ID)">
                      <v-list-tile-content>
                        Διαγραφή
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon color="error"> mdi-tag-remove</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-chip  small disabled v-if=" expired(props.item)" >
              Έληξε
            </v-chip>
            ID:{{props.item.ID}}
          </v-list-tile>
          <v-divider></v-divider>

        </v-list>

      </v-flex>
      <v-divider></v-divider>
    </v-data-iterator>
  </v-card>
</template>

<script>
  import StoreState from "@/assets/StoreState";
  import ApiData from "../assets/ApiData";
  import DatePicker from "../components/DatePicker";
  import DescriptionEditor from "../components/DescriptionEditor";
  import OfferFieldEditor from "./OfferFieldEditor";

  export default {
    name: "Offers",
    data: () => ({
      search:"",
      rowsPerPageItems: [10, 15, 25],
      pagination: {
        rowsPerPage: 10
      },
      b2b: StoreState.b2b,
    }),
    components: {OfferFieldEditor, DescriptionEditor, DatePicker},
    methods: {
      filterRelations(offerID) {
        StoreState.filterRelations({offerID: offerID})
      },
      expired(offer) {
        return StoreState.isOfferExpired(offer)

      },
      toggleOffer(id, status){
        if (!window.confirm("Είστε σίγουροι;")) return;
        StoreState.messages.isLoading = true;
        ApiData.toggleOffer(id,status).then(resp=>{
          if(resp){
            StoreState.updateRelations().then(
              resp=>{
                StoreState.messages.isLoading = false;
                this.$notify({
                  group: 'messages',
                  type: 'success',
                  text: 'Αποθηκεύτηκε'
                });
              }
            )
          }
        })
      },
      updateOfferField(id, field, value) {
        if (!window.confirm("Είστε σίγουροι;")) return;
        StoreState.messages.isLoading = true;
        ApiData.updateOfferField(id, field, value).then(
          resp => {
            if (resp) {
              StoreState.updateOfferField(id, field, value);
            }
            StoreState.messages.isLoading = false;
            this.$notify({
              group: 'messages',
              type: 'success',
              text: 'Αποθηκεύτηκε'
            });
          }
        ).catch(err => {
          this.$notify({
            group: "messages",
            type: 'error',
            text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
          });
          StoreState.messages.isLoading = false;
          StoreState.messages.error = err;
        })
      },
      deleteOffer(id) {
        if (!window.confirm("Η ενέργεια αυτή θα διαγράψει την προσφρορά, αλλά και τις προσβάσεις που έχουν σε αυτή οι πελάτες, είστε σίγουροι;")) return;
        StoreState.messages.isLoading = true;
        ApiData.deleteOffer(id).then(
          resp => {
            if (resp) {
              StoreState.deleteOffer(id);
            }
            StoreState.messages.isLoading = false;
            this.$notify({
              group: 'messages',
              type: 'success',
              text: 'Αποθηκεύτηκε'
            });

          }
        ).catch(err => {
          this.$notify({
            group: "messages",
            type: 'error',
            text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
          });
          StoreState.messages.isLoading = false;
          StoreState.messages.error = err;

        });
      },
    }
  }

</script>

<style scoped>
  .scroll-y {
    overflow: auto;
  }

  .boxes-front {
    max-height: 50vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Offers.vue